/* PCatch! USD Converter — injects above Add to Cart, live exchange rate */
(function(){
  'use strict';
  var CK='pc_r', CT='pc_t', TTL=3600000;

  function buildWidget(){
    var d = document.createElement('div');
    d.id = 'pcatch-usd-converter';
    d.setAttribute('style',[
      'background:#f8f9fa',
      'border:1.5px solid #e2e8f0',
      'border-radius:10px',
      'padding:14px 18px',
      'margin-bottom:14px',
      'font-family:inherit'
    ].join(';'));
    d.innerHTML =
      '<p style="font-size:12px;color:#718096;margin:0 0 4px;text-transform:uppercase;letter-spacing:.5px;font-weight:500">US Estimated price</p>'+
      '<p id="pcatch-usd-price" style="font-size:22px;font-weight:700;color:#1a2e2d;margin:0 0 4px;line-height:1">Loading...</p>'+
      '<p style="font-size:11px;color:#a0aec0;margin:0">Charged securely in Brazilian Real (BRL)</p>';
    return d;
  }

  function getAnchor(){
    var selectors = [
      '.product-form-buy-button',
      '.product-form__buttons',
      '.addtocart_and_selector_wrapper',
      'product-form .product-form__buttons',
      'product-form',
      '.product-form'
    ];
    for(var i=0; i<selectors.length; i++){
      var el = document.querySelector(selectors[i]);
      if(el) return el;
    }
    return null;
  }

  function inject(){
    if(document.getElementById('pcatch-usd-converter')) return true;
    var anchor = getAnchor();
    if(!anchor) return false;
    anchor.parentNode.insertBefore(buildWidget(), anchor);
    return true;
  }

  function getPrice(){
    var opt = document.querySelector('[name="id"] option:checked');
    if(opt){
      var raw = opt.getAttribute('data-price') || opt.getAttribute('price');
      if(raw && +raw > 0) return +raw / 100;
    }
    var priceSelectors = [
      '.price__regular .price-item--regular',
      '.price-item.price-item--regular',
      '.price-item--sale',
      '[data-product-price]',
      '.product__price .price',
      '.price .price-item'
    ];
    for(var i=0; i<priceSelectors.length; i++){
      var el = document.querySelector(priceSelectors[i]);
      if(el){
        var txt = el.textContent.replace(/[^0-9,.]/g,'').replace(',','.');
        var v = parseFloat(txt);
        if(!isNaN(v) && v > 0) return v;
      }
    }
    return 0;
  }

  function fmt(amount){ return '$' + amount.toFixed(2) + ' USD'; }

  function render(rate){
    var el = document.getElementById('pcatch-usd-price');
    if(!el) return;
    var brl = getPrice();
    el.textContent = brl > 0 ? fmt(brl / rate) : '--';
  }

  function loadRate(cb){
    var now = Date.now(), r, ts;
    try{ r = parseFloat(sessionStorage.getItem(CK)); ts = +sessionStorage.getItem(CT); }catch(e){}
    if(r > 0 && ts && (now - ts) < TTL){ cb(r); return; }
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function(res){ return res.json(); })
      .then(function(d){
        var rate = d.rates && d.rates.BRL;
        if(!rate) throw 0;
        try{ sessionStorage.setItem(CK, rate); sessionStorage.setItem(CT, now); }catch(e){}
        cb(rate);
      })
      .catch(function(){
        fetch('https://api.frankfurter.app/latest?from=USD&to=BRL')
          .then(function(res){ return res.json(); })
          .then(function(d){
            var rate = d.rates && d.rates.BRL;
            if(!rate) throw 0;
            try{ sessionStorage.setItem(CK, rate); sessionStorage.setItem(CT, now); }catch(e){}
            cb(rate);
          })
          .catch(function(){ cb(5.75); });
      });
  }

  function init(){
    if(!inject()){
      var ob = new MutationObserver(function(){
        if(inject()){ ob.disconnect(); loadRate(render); }
      });
      ob.observe(document.body, {childList:true, subtree:true});
      setTimeout(function(){ ob.disconnect(); }, 6000);
    }
    loadRate(render);

    document.addEventListener('variant:changed', function(e){
      if(e.detail && e.detail.variant && e.detail.variant.price){
        var rate = parseFloat(sessionStorage.getItem(CK)) || 5.75;
        var el = document.getElementById('pcatch-usd-price');
        if(el) el.textContent = fmt((e.detail.variant.price / 100) / rate);
      }
    });

    document.addEventListener('change', function(e){
      if(e.target && e.target.name === 'id'){
        setTimeout(function(){ loadRate(render); }, 250);
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();